import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import { QbrCloneVersionContent } from './QbrCloneVersionContent'

interface IProps {
  show: boolean
  selectedVersion: IQBRDocumentsListItem
  closeDialog: () => void
  qbrDocumentsData: IQBRDocumentsListItem[]
  setQbrDocumentsData: (value: IQBRDocumentsListItem[]) => void
}

export const QbrCloneVersionDialog = ({
  selectedVersion,
  show,
  closeDialog,
  qbrDocumentsData,
  setQbrDocumentsData,
}: IProps) => {
  const contentProps = useMemo(
    () => ({
      selectedVersion,
      closeDialog,
      qbrDocumentsData,
      setQbrDocumentsData,
    }),
    [selectedVersion, closeDialog, qbrDocumentsData, setQbrDocumentsData]
  )

  return (
    <ModalDialog
      size={'xs'}
      content={QbrCloneVersionContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}
